(function () {
  var root = document.querySelector('[data-welcome-popup]');
  if (!root) return;

  var STORAGE_KEY = 'mnksWelcomePopupSeen';
  var closers = root.querySelectorAll('[data-popup-close]');
  var delay = parseFloat(root.getAttribute('data-delay') || '1') * 1000;
  var opened = false;

  function open() {
    if (opened) return;
    opened = true;
    root.setAttribute('data-open', '');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var emailInput = root.querySelector('input[type="email"]');
    if (emailInput) {
      try { emailInput.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function close() {
    root.removeAttribute('data-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try { window.sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  closers.forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.hasAttribute('data-open')) close();
  });

  var alreadySeen = false;
  try { alreadySeen = window.sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

  // If the customer form on this page just posted back successfully (Shopify reloads
  // the page after a real form submit), show the confirmation immediately instead of
  // waiting out the normal delay or hiding it because "seen" was never set.
  var justSubmitted = !!root.querySelector('.form-success');

  if (justSubmitted) {
    open();
  } else if (!alreadySeen) {
    window.setTimeout(open, delay);
  }
})();
